import type { Foyer, Scenario, ScenarioDiff } from '@/engine/types';
import type { AuthUser } from '@/stores/auth-store';
import { genId } from '@/utils/id';
import { resolveCreatedBy } from './ownership';

export interface CreateScenarioInput {
  foyer: Pick<Foyer, 'id' | 'storageMode'>;
  user: AuthUser | null;
  name: string;
  diff?: ScenarioDiff;
  id?: string;
  now?: string;
}

function emptyDiff(): ScenarioDiff {
  return { lines: {}, categories: {}, domains: {}, blocks: {} };
}

export function createScenario(input: CreateScenarioInput): Scenario {
  const { foyer, user, name, diff, id, now } = input;
  const timestamp = now ?? new Date().toISOString();
  return {
    id: id ?? genId(),
    foyerId: foyer.id,
    name,
    createdBy: resolveCreatedBy(foyer, user),
    diff: diff ?? emptyDiff(),
    createdAt: timestamp,
    updatedAt: timestamp,
  };
}
